export default (() => {

    const global = { 
        elements: {},
        pageData: {}, 
    };

    const defaultErrorLogEndpoint = 'Apply/LogTinkIframeError';

    function initialiseAccountCheck () {
        global.elements = { 
            iframe: document.querySelector('[data-tink-iframe]'),
            form: document.querySelector('[data-redirect-form]'),
            reportId: document.querySelector('[data-tink-report-id]')
        };

        global.pageData = {errorLogEndpoint: global.elements.iframe.dataset.logTinkErrorEndpoint ?? defaultErrorLogEndpoint};

        window.addEventListener('message', handlePostMessageAccountCheck, false);
    }

    function handlePostMessageAccountCheck(event) {
        try {
            if (event.origin !== 'https://link.tink.com') {
                return;
            }

            const { 
                type, 
                data,
                error
            } = JSON.parse(event.data);

            if (type === 'reports') {
                global.elements.reportId.value = data.transaction_report_id;
                global.elements.form.submit();
            } else if (type === 'error' || (type === 'credentials' && error !== null)) {
                console.log(`Tink Link returned with error status: ${error.status} and error message: ${error.message}.`);

                const config = {
                    data: {
                        status: error.status,
                        message: error.message,
                        reason: error.reason,
                    },
                    contentType: 'application/json',
                    url: global.pageData.errorLogEndpoint,
                };

                wealthify.request.send(config)
                    .then(() => {
                        global.elements.reportId.value = null;
                        global.elements.form.submit();
                    });
            }
        } catch (e) {
            console.log('Error handling post message from iframe.');
        }
    }
    
    return { initialiseAccountCheck };
    
})();